import keys from '@debbie/common/dist/cache/keys.js';
import { canReceiveCases, CreditorState, } from '@debbie/common/dist/creditor/index.js';
import { validateNewCustomer, } from '@debbie/common/dist/customers/index.js';
import { Site, Currency, Entity } from '@debbie/common/dist/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { cases, updates } from '@debbie/cortex/dist/api/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { customersEntity } from '@debbie/cortex/dist/customers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { ultimateCreditorOptions, useUltimateCreditors, } from '@debbie/cortex/dist/ultimate-creditors/index.js';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../utils/errors.js';
import CreateCustomer from '../../Customers/CreateCustomer.js';
import { Row, Col } from '../../Grid/index.js';
import { Panel, Button, Select, Checkbox, CaseGroupSelect, CreditorSelect, } from '../../index.js';
import NewEntityProperties from '../../Properties/NewEntityProperties.js';
import { CaseCreationStep } from '../CaseCreator.js';
const Create = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const selectedCreditor = useSelector((s) => s.selectedCreditor);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const tenant = useTenant();
    const [stateCreditor, setCreditor] = useState(null);
    const [ultimateCreditorId, setUltimateCreditorId] = useState(null);
    const [currency, setCurrency] = useState(Currency.DKK);
    const [customer, setCustomer] = useState(null);
    const [existingCustomer, setExistingCustomer] = useState(null);
    const createCaseMutation = useMutation(async (params) => {
        let _customerId = params.customerId;
        if (!_customerId && params.customer) {
            const newCustomer = await customersAPI.create(stateCreditor, params.customer);
            _customerId = newCustomer.customerId;
        }
        if (!_customerId) {
            throw new Error('Failed creating customer');
        }
        if (!params.existingCustomer && !params.customer) {
            throw new Error('No customer added');
        }
        if (!stateCreditor) {
            throw new Error('Creditor not defined');
        }
        const created = await cases.create({
            customerId: _customerId,
            creditorId: stateCreditor,
            ultimateCreditorId: ultimateCreditorId || undefined,
            caseVouchers: [],
            currency,
            groupId: caseGroupId || undefined,
            properties: properties || undefined,
        });
        if (opposition) {
            await updates.make({
                referenceId: created.id,
                updateTypeId: UpdateType.OPPOSITION,
            });
        }
        q.invalidate(keys.write.modify(customersEntity, _customerId));
        return created;
    }, {
        onSuccess: (created) => {
            c.redirect.redirect(props.genLink(created.id, CaseCreationStep.Economy));
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.case);
        },
    });
    const [opposition, setOpposition] = useState(false);
    const [caseGroupId, setCaseGroupId] = useState(null);
    const [properties, setProperties] = useState(null);
    const [propertiesValid, setPropertiesValid] = useState(true);
    const creditor = allCreditors && allCreditors.find((c) => c.creditorId === stateCreditor);
    const ultimateCreditorsLoadable = useUltimateCreditors(stateCreditor);
    const ultimateCreditors = h.hasData(ultimateCreditorsLoadable)
        ? ultimateCreditorsLoadable.data
        : null;
    useEffect(() => {
        setUltimateCreditorId(null);
    }, [stateCreditor]);
    const ultimateCreditorSelectOptions = useMemo(() => ultimateCreditorOptions(lang.ultimateCreditors.none, ultimateCreditors || []), [ultimateCreditors, lang]);
    useEffect(() => {
        if (tenant) {
            setCurrency(tenant.currency);
        }
    }, [tenant]);
    useEffect(() => {
        const creditorsWithCaseGroup = allCreditors && allCreditors.filter((c) => !!c.defaultCaseGroupId);
        const creditorWithCaseGroup = creditorsWithCaseGroup &&
            creditorsWithCaseGroup.length === 1 &&
            creditorsWithCaseGroup[0]
            ? creditorsWithCaseGroup[0].creditorId
            : null;
        setCreditor(stateCreditor || selectedCreditor || creditorWithCaseGroup);
    }, [allCreditors, selectedCreditor]);
    useEffect(() => {
        if (allCreditors) {
            if (allCreditors.length === 1 && !stateCreditor) {
                setCreditor(allCreditors[0].creditorId);
            }
            else if (tenant?.type === TenantType.AccountsReceivable &&
                !stateCreditor) {
                const activeCreditors = allCreditors.filter((c) => c.state === CreditorState.Active);
                if (activeCreditors.length === 1) {
                    setCreditor(activeCreditors[0].creditorId);
                }
            }
        }
    }, [allCreditors]);
    const newCustomerErrors = existingCustomer
        ? []
        : validateNewCustomer(customer);
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, null, lang.cases.newCaseCreateExplainer),
        React.createElement(Panel, { header: lang.cases.newCaseCreate },
            Site.Client !== site && (React.createElement(Row, null,
                React.createElement(Col, { width: "12" },
                    (tenant?.type === TenantType.Agency ||
                        tenant?.type === null) && (React.createElement(CreditorSelect, { placeholder: lang.creditors.creditor, value: stateCreditor ?? null, onChange: setCreditor, filter: canReceiveCases })),
                    React.createElement(CaseGroupSelect, { placeholder: lang.cases.caseGroup, value: caseGroupId, onChange: (id) => {
                            setPropertiesValid(true);
                            setCaseGroupId(id);
                        } }),
                    caseGroupId != null && (React.createElement(NewEntityProperties, { propRef: Entity.Case, caseGroupId: caseGroupId, propsValid: (v) => setPropertiesValid(v), onChange: (p) => {
                            let exists = false;
                            setProperties(properties && properties.length > 0
                                ? properties
                                    .map((prop) => {
                                    if (prop.handle === p.handle) {
                                        exists = true;
                                        return p;
                                    }
                                    else {
                                        return prop;
                                    }
                                })
                                    .concat(exists ? [] : [p])
                                : [p]);
                        } }))))),
            stateCreditor && ultimateCreditors && ultimateCreditors.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, lang.ultimateCreditors.ultimateCreditor),
                React.createElement(Select, { label: lang.ultimateCreditors.ultimateCreditor, options: ultimateCreditorSelectOptions, selected: ultimateCreditorId ? [ultimateCreditorId] : [], onChange: (selected) => {
                        setUltimateCreditorId(selected[0] || null);
                    } }))),
            React.createElement("h3", null, lang.financials.currency),
            React.createElement(Select, { label: lang.financials.currency, options: Object.values(Currency).map((currencyOption) => ({
                    value: currencyOption,
                    label: currencyOption,
                })), selected: [currency || ''], onChange: (selected) => {
                    const val = selected[0];
                    if (val && Object.values(Currency).includes(val)) {
                        setCurrency(val);
                    }
                } })),
        React.createElement(Panel, { header: lang.customers.parties },
            React.createElement(CreateCustomer, { onChange: (customer) => {
                    setCustomer(customer);
                }, onChangeExistingCustomer: (existingCustomer) => {
                    setExistingCustomer(existingCustomer);
                }, creditorId: creditor ? creditor.creditorId : null }),
            React.createElement("br", null),
            React.createElement(Checkbox, { checked: opposition, onChange: (e) => setOpposition(e.target.checked), placeholder: lang.cases.debtorHaveObjections, style: { marginBottom: '0px' } })),
        React.createElement("div", null,
            React.createElement(Button, { loading: createCaseMutation.isLoading, disabled: !(stateCreditor !== null &&
                    (existingCustomer || newCustomerErrors.length === 0) &&
                    propertiesValid), tooltip: getDisabledReasons({
                    stateCreditor,
                    existingCustomer,
                    newCustomerErrors,
                    propertiesValid,
                    lang,
                }), onClick: () => {
                    createCaseMutation.mutate({
                        customerId: existingCustomer?.customerId,
                        customer,
                        existingCustomer,
                    });
                } }, lang.misc.create))));
};
const getDisabledReasons = (params) => {
    const { stateCreditor, existingCustomer, newCustomerErrors, propertiesValid, lang, } = params;
    const reasons = [];
    if (stateCreditor === null) {
        reasons.push(`${lang.errors.missing}: ${lang.creditors.creditor}`);
    }
    if (!existingCustomer && newCustomerErrors.length > 0) {
        reasons.push(toReadableError(newCustomerErrors, lang));
    }
    if (!propertiesValid) {
        reasons.push(`${lang.errors.invalid}: ${lang.properties.properties}`);
    }
    if (reasons.length === 0) {
        return undefined;
    }
    return reasons.join('. ');
};
const toReadableError = (errors, lang) => {
    const missingOrInvalid = new Set();
    for (const error of errors) {
        missingOrInvalid.add(error.type);
    }
    let parts = [];
    for (const error of missingOrInvalid) {
        switch (error) {
            case 'invalid_email_or_missing_address': {
                parts.push(`${lang.cases.email} ${lang.misc.or} ${lang.cases.address}`);
                break;
            }
            case 'invalid_name': {
                parts.push(`${lang.cases.debtorName}`);
                break;
            }
            case 'invalid_phone': {
                parts.push(`${lang.cases.phone}`);
                break;
            }
            case 'invalid_register_id': {
                parts.push(`${lang.customers.private} ${lang.misc.or} ${lang.customers.company}`);
                break;
            }
            case 'missing_ref_id': {
                parts.push(`${lang.customers.referenceId}`);
                break;
            }
            case 'invalid_user': {
                parts.push(`${lang.users.users}`);
                break;
            }
            case 'missing_customer': {
                parts.push(`${lang.customers.parties}`);
                break;
            }
        }
    }
    return `${lang.errors.missing} ${lang.misc.or} ${lang.errors.invalid}: ${parts.join(', ')}`;
};
export default Create;
//# sourceMappingURL=Create.js.map